<template>
  <component
    :is="statusTag"
    :class="[
      'availability-status',
      getAvailabilityStatus.class,
      theme ? `availability-status--${theme}` : null,
      showSmallIndicatorDot ? 'availability-status--small-indicator-dot' : null,
    ]"
  >
    <tooltip-fi
      :class="['availability-status__tooltip', customTooltipClass]"
      :tooltip="getAvailabilityStatus.text"
      :custom-class="getAvailabilityStatus.class"
      :disabled="disableTooltip || isLG"
    >
      <template #trigger>
        <span :class="['availability-status__trigger', getAvailabilityStatus.class]" />
      </template>
    </tooltip-fi>
    <div
      v-if="isLG || theme === 'buy-box' || theme === 'checkout' || showStatusText"
      class="availability-status__text"
      data-test="availability-status"
      :data-test-2="getAvailabilityStatus.speed"
    >
      {{ getAvailabilityStatus.text }}
    </div>
  </component>
</template>

<script>
import TooltipFi from '@/components/atoms/tooltip-fi/TooltipFi.vue';
import breakpointMixin from '@/mixins/breakpointMixin.vue';

export default {
  name: 'AvailabilityStatus',
  components: {
    TooltipFi,
  },
  mixins: [breakpointMixin],
  props: {
    deliverySpeed: {
      type: String,
      default: 'NODELIVERY',
    },
    disableTooltip: {
      type: Boolean,
      default: false,
    },
    customTooltipClass: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    theme: {
      type: String,
      default: '',
    },
    tag: {
      type: String,
      default: '',
    },
    showStatusText: {
      type: Boolean,
      default: false,
    },
    showSmallIndicatorDot: {
      type: Boolean,
      default: false,
    },
    stockLevels: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      allowedTags: ['div', 'span'],
    };
  },
  computed: {
    statusTag() {
      let tag = 'div';

      if (this.allowedTags.includes(this.tag)) {
        tag = this.tag;
      }

      return tag;
    },
    getAvailabilityStatus() {
      const stockWithCode = this.stockLevels?.find(({ warehouse }) => warehouse?.code);
      const code = stockWithCode?.warehouse.code;

      const deliverySpeed =
        (code &&
          this.$dict.get(
            `online-Shop.Product.Warehouse.${code}-${this.deliverySpeed}-Speed`,
            null,
            { noDevFallback: true },
          )) ||
        this.deliverySpeed;
      const warehouseText =
        code &&
        this.$dict.get(`online-Shop.Product.Warehouse.${code}-${this.deliverySpeed}`, null, {
          noDevFallback: true,
        });

      const isFastDelivery = deliverySpeed === 'FASTDELIVERY';
      const isSlowDelivery = !deliverySpeed || deliverySpeed === 'SLOWDELIVERY';
      let availabilityText = this.$dict.get('online-Shop.Product.No-Delivery');
      let availabilityClass = 'availability-status--no-delivery';

      if (isFastDelivery) {
        availabilityText = this.$dict.get('online-Shop.Product.Fast-Delivery');
        availabilityClass = 'availability-status--fast-delivery';
      } else if (isSlowDelivery) {
        availabilityText = this.$dict.get('online-Shop.Product.Slow-Delivery');
        availabilityClass = 'availability-status--slow-delivery';
      }

      return {
        class: availabilityClass,
        text: warehouseText || availabilityText,
        speed: deliverySpeed,
      };
    },
  },
};
</script>

<style scoped src="./availability-status" />

<style src="./availability-status-unscoped" />
